import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { PHONE, PHONE_HREF } from '../contact.config';

/**
 * Sticky floating CTA bar on mobile — appears after scrolling past 400px.
 * Hidden on the booking page itself to avoid redundancy.
 */
export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Don't show on the booking page itself
  if (pathname === '/book-online') return null;

  return (
    <>
      <style>{`
        .sticky-cta {
          position:fixed; bottom:0; left:0; right:0; z-index:998;
          background:rgba(250,250,248,0.97); backdrop-filter:blur(16px);
          border-top:1px solid var(--border-soft);
          box-shadow:0 -4px 24px rgba(100,80,40,0.1);
          padding:10px 16px;
          display:none; align-items:center; justify-content:space-between; gap:12px;
          transform:translateY(100%);
          transition:transform 0.4s cubic-bezier(0.4,0,0.2,1);
        }
        .sticky-cta.show { transform:translateY(0); }
        .sticky-cta-text {
          font-family:'DM Sans',sans-serif; font-size:0.82rem; font-weight:500;
          color:var(--text); line-height:1.3;
        }
        .sticky-cta-text span {
          display:block; font-size:0.7rem; font-weight:300; color:var(--text-dim);
          margin-top:2px;
        }
        .sticky-cta-btn {
          font-family:'Outfit',sans-serif; font-size:0.58rem; font-weight:700;
          letter-spacing:0.12em; text-transform:uppercase;
          color:#fff; background:var(--gold); border:none;
          padding:10px 20px; cursor:pointer; text-decoration:none;
          display:inline-flex; align-items:center; gap:6px;
          white-space:nowrap; flex-shrink:0;
          transition:background 0.3s;
        }
        .sticky-cta-btn:hover { background:var(--text); }
        .sticky-cta-actions { display:flex; gap:8px; flex-shrink:0; }
        .sticky-cta-call {
          width:40px; display:inline-flex; align-items:center; justify-content:center;
          color:var(--gold); background:var(--bg-card); border:1.5px solid var(--gold-border);
          text-decoration:none; transition:all 0.3s;
        }
        .sticky-cta-call:hover { border-color:var(--gold); background:var(--gold-pale); }
        @media(max-width:768px) {
          .sticky-cta { display:flex; }
        }
      `}</style>
      <div className={`sticky-cta${visible ? ' show' : ''}`} role="complementary" aria-label="Book consultation">
        <div className="sticky-cta-text">
          Free In-Home Quote
          <span>All Adelaide suburbs</span>
        </div>
        <div className="sticky-cta-actions">
          <a href={PHONE_HREF} className="sticky-cta-call" aria-label={`Call ${PHONE}`}><Phone size={15}/></a>
          <Link to="/book-online" className="sticky-cta-btn">
            Book Now <ArrowRight size={12} />
          </Link>
        </div>
      </div>
    </>
  );
}
